var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34843 12.4922C8.36522 12.5146 8.38668 12.5327 8.41118 12.5452C8.43567 12.5577 8.46256 12.5641 8.48981 12.5641C8.51706 12.5641 8.54395 12.5577 8.56845 12.5452C8.59294 12.5327 8.6144 12.5146 8.63119 12.4922L11.1446 9.17109C11.2367 9.04922 11.1536 8.86875 11.0033 8.86875H9.34035V0.9375C9.34035 0.834375 9.25956 0.75 9.16082 0.75H7.81432C7.71558 0.75 7.63479 0.834375 7.63479 0.9375V8.86641H5.97636C5.826 8.86641 5.74297 9.04688 5.83498 9.16875L8.34843 12.4922ZM16.7034 11.6719H15.3569C15.2582 11.6719 15.1774 11.7563 15.1774 11.8594V15.4688H1.80224V11.8594C1.80224 11.7563 1.72145 11.6719 1.6227 11.6719H0.276212C0.177469 11.6719 0.0966797 11.7563 0.0966797 11.8594V16.5C0.0966797 16.9148 0.417594 17.25 0.814809 17.25H16.1648C16.562 17.25 16.8829 16.9148 16.8829 16.5V11.8594C16.8829 11.7563 16.8022 11.6719 16.7034 11.6719Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f3196308.svg";
export { ForwardRef as ReactComponent };